export type Locale = 'en' | 'ar'
export type QualityTier = 'high' | 'balanced' | 'lite' | 'poster'

export const ACT_RANGES = [
  // Section start / max scroll: 1600vh authored height minus one 100vh viewport.
  { id: 'act-00', start: 0, end: 140 / 1500 },
  { id: 'act-01', start: 140 / 1500, end: 320 / 1500 },
  { id: 'act-02', start: 320 / 1500, end: 460 / 1500 },
  { id: 'act-03', start: 460 / 1500, end: 640 / 1500 },
  { id: 'act-04', start: 640 / 1500, end: 910 / 1500 },
  { id: 'act-05', start: 910 / 1500, end: 1130 / 1500 },
  { id: 'act-06', start: 1130 / 1500, end: 1300 / 1500 },
  { id: 'act-07', start: 1300 / 1500, end: 1430 / 1500 },
  { id: 'act-08', start: 1430 / 1500, end: 1 },
] as const

export interface SceneFrameState {
  progress: number
  velocity: number
  pointerX: number
  pointerY: number
  pointerActive: boolean
  locale: Locale
  reducedMotion: boolean
  verticalCapture: boolean
  quality: QualityTier
  activeAct: number
  actProgress: number
}

const clamp01 = (value: number) => Math.min(1, Math.max(0, value))

export function resolveAct(progress: number) {
  const safeProgress = clamp01(progress)
  const index = ACT_RANGES.findIndex(
    (range, rangeIndex) =>
      safeProgress >= range.start &&
      (safeProgress < range.end || rangeIndex === ACT_RANGES.length - 1),
  )
  const activeAct = index === -1 ? ACT_RANGES.length - 1 : index
  const range = ACT_RANGES[activeAct]
  const actProgress = clamp01(
    (safeProgress - range.start) / Math.max(0.0001, range.end - range.start),
  )

  return { activeAct, actProgress }
}

const initialResolved = resolveAct(0)

const state: SceneFrameState = {
  progress: 0,
  velocity: 0,
  pointerX: 0,
  pointerY: 0,
  pointerActive: false,
  locale: 'en',
  reducedMotion: false,
  verticalCapture: false,
  quality: 'high',
  ...initialResolved,
}

export const sceneStore = {
  read: () => state,
  update: (patch: Partial<SceneFrameState>) => {
    if (typeof patch.progress === 'number') {
      const progress = clamp01(patch.progress)
      Object.assign(state, patch, { progress, ...resolveAct(progress) })
      return
    }
    Object.assign(state, patch)
  },
}
